import {
  Activity,
  Anchor,
  Bot,
  Brain,
  DollarSign,
  // Eye removido em WPP-001.48 AC15 — era usado APENAS pela rota Revisão IA,
  // que foi escondida do menu até a tabela wpp_ai_review_queue ser criada
  // (TD-WPP-REVISAO). Reincluir quando reativar a rota.
  FileText,
  Headset,
  HeartPulse,
  LayoutDashboard,
  Megaphone,
  MessageSquare,
  RefreshCcw,
  Settings2,
  Smile,
  TrendingUp,
  Users,
  Wrench,
  Workflow,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  path: string;
  title: string;
  icon: LucideIcon;
  group: "dashboards" | "gestao" | "sistema" | "whatsapp";
}

export const navItems: NavItem[] = [
  { path: "/overview", title: "Overview", icon: LayoutDashboard, group: "dashboards" },
  { path: "/revenue", title: "Revenue", icon: DollarSign, group: "dashboards" },
  { path: "/acquisition", title: "Aquisicao", icon: TrendingUp, group: "dashboards" },
  { path: "/retention", title: "Retencao", icon: RefreshCcw, group: "dashboards" },
  { path: "/engagement", title: "Engagement", icon: Activity, group: "dashboards" },
  { path: "/efficacy", title: "Eficacia", icon: HeartPulse, group: "dashboards" },
  { path: "/feedback", title: "Feedback", icon: Smile, group: "dashboards" },
  { path: "/users", title: "Usuarios", icon: Users, group: "gestao" },
  { path: "/patients", title: "Pacientes", icon: Brain, group: "gestao" },
  { path: "/marketing", title: "Marketing", icon: Megaphone, group: "gestao" },
  { path: "/atendimento", title: "Atendimento", icon: Headset, group: "whatsapp" },
  { path: "/whatsapp/dashboard", title: "Dashboard WPP", icon: LayoutDashboard, group: "whatsapp" },
  { path: "/whatsapp/templates", title: "Templates", icon: FileText, group: "whatsapp" },
  { path: "/whatsapp/campanhas", title: "Campanhas", icon: Megaphone, group: "whatsapp" },
  { path: "/whatsapp/flows", title: "Flows", icon: Workflow, group: "whatsapp" },
  { path: "/whatsapp/agentes", title: "Agentes", icon: Bot, group: "whatsapp" },
  { path: "/whatsapp/anchors", title: "Ancoras", icon: Anchor, group: "whatsapp" },
  // WPP-001.48 AC15: rota `/whatsapp/revisao` escondida do menu. A página
  // renderiza mas a tabela `wpp_ai_review_queue` (esperada como backing
  // store) NÃO EXISTE no schema — o roadmap de WPP-001.20 "review queue
  // observability" ficou parcial. UI fica eternamente em "sem dados".
  // Plano de implementação completo: docs/TECH-DEBT.md TD-WPP-REVISAO.
  // { path: "/whatsapp/revisao", title: "Revisao IA", icon: Eye, group: "whatsapp" },
  { path: "/whatsapp/config", title: "Configuracoes", icon: MessageSquare, group: "whatsapp" },
  { path: "/system", title: "Sistema", icon: Settings2, group: "sistema" },
  { path: "/audit", title: "Audit", icon: FileText, group: "sistema" },
  { path: "/config", title: "Config", icon: Wrench, group: "sistema" },
];

export function getRouteTitle(pathname: string): string {
  if (pathname.startsWith("/users/") && pathname.split("/").length === 3) {
    return "Perfil do Usuario";
  }

  if (pathname === "/nps") return "Feedback";
  if (pathname === "/bi-clinical") return "Pacientes";
  if (pathname === "/whatsapp/inbox") return "WhatsApp - Atendimento";
  if (pathname === "/atendimento") return "Atendimento";
  if (pathname === "/whatsapp/dashboard") return "WhatsApp - Dashboard";
  if (pathname === "/whatsapp/templates") return "WhatsApp - Templates";
  if (pathname === "/whatsapp/campanhas") return "WhatsApp - Campanhas";
  if (pathname === "/whatsapp/flows") return "WhatsApp - Flows";
  if (pathname === "/whatsapp/agentes") return "WhatsApp - Agentes";
  if (pathname === "/whatsapp/anchors") return "WhatsApp - Ancoras";
  // WPP-001.48 AC15: título preservado para o caso de acesso direto via URL
  // antes do gate de "Feature em desenvolvimento" no router. Útil para que
  // bookmarks antigos mostrem algo coerente no breadcrumb se renderizarem
  // por uma fração de segundo durante o redirect.
  if (pathname === "/whatsapp/revisao") return "WhatsApp - Revisao IA";
  if (pathname === "/whatsapp/config") return "WhatsApp - Configuracoes";

  const item = navItems.find((candidate) => candidate.path === pathname);
  return item?.title ?? "Centro de Comando";
}
